<template>
  <main>
    <modalInformacionUsuario :usuario="usuario"></modalInformacionUsuario>
    <page-header-compact>
        <span class="d-block">Curso para la preparación de la maternidad y la paternidad (Embarazo actual No. {{ idEmbarazo || (embarazo_actual ? (embarazo_actual.id || embarazo_actual.id_embarazo) : '') || '—' }})</span>
        <template v-slot:button>
          <button
            type="button"
            class="btn btn-primary btn-sm shadow-sm mx-1"
            title="Imprimir sesiones de maternidad"
            @click="imprimirSesiones"
          >
            Imprimir sesiones <i class="fas fa-print fa-fw ml-1"></i>
          </button>
          <router-link  :to="{ name: 'historias.perfil.usuario', params: { 
            idUsuario: usuario.id
            }}"
            class="btn btn-success btn-sm shadow-sm mx-1">
              Regresar al perfil del paciente <i class="fas fa-history fa-fw"></i>
          </router-link>
        </template>
    </page-header-compact>
    <div class="container-xl px-4">
      <div class="card mt-2">
        <cardInformacionUsuario :usuario="usuario"></cardInformacionUsuario>
      </div>
      <div class="card mt-2">
        <indexCursoMaternidad 
        :idUsuario="idUsuario" 
        :idEmbarazo="idEmbarazo"></indexCursoMaternidad>
      </div> 
    </div>
  </main>
</template>
<script>
import cardInformacionUsuario from "../informacionUsuario/cardInformacionUsuario";
import usuarioService from "../../../../services/usuarioService";
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import modalInformacionUsuario from "../informacionUsuario/modalInformacionUsuario";
import embarazoService from '../../../../services/embarazoService';
import indexCursoMaternidad from './index.vue';
import { printSesiones, printSesionesPorUsuario } from '../../../../services/cursoMaternidadService';

export default {
  components: {
    cardInformacionUsuario,
    modalInformacionUsuario,
    PageHeaderCompact,
    indexCursoMaternidad
  },
  data() {
    return {
      usuario: {},
      embarazo_actual: {},
      idUsuario: this.$route.params.idUsuario,
      idEmbarazo: this.$route.params.idEmbarazo,
    };
  },
  methods: {
    async cargarUsuario(id) {
      const response = await usuarioService.show(id);
      this.usuario = response.data;

      const res_embarazo_actual = await embarazoService.showByLast(id);
      this.embarazo_actual = res_embarazo_actual.data;
      if (!this.idEmbarazo && this.embarazo_actual && (this.embarazo_actual.id || this.embarazo_actual.id_embarazo)) {
        this.idEmbarazo = this.embarazo_actual.id || this.embarazo_actual.id_embarazo;
      }
    },
    imprimirSesiones() {
      const embarazoId = this.idEmbarazo || this.embarazo_actual?.id || this.embarazo_actual?.id_embarazo;
      if (embarazoId) {
        window.open(printSesiones(embarazoId), '_blank');
      } else if (this.idUsuario || this.usuario?.id) {
        window.open(printSesionesPorUsuario(this.idUsuario || this.usuario.id), '_blank');
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Atención',
          text: 'No se identificó el embarazo ni el paciente para imprimir las sesiones.'
        });
      }
    }
  },
  async created() {
    this.LoaderSpinnerShow();
    await this.cargarUsuario(this.$route.params.idUsuario);
    this.LoaderSpinnerHide();
  },
};
</script>
